/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { SettingTable } from '@finbeat/react-toolkit';
import Table from 'models/api/table';
import Id from 'models/id';

export const settingsToWorkplace = (items: Table<SettingTable>) => ({
    rowsCount: items.rowsCount,
    data: items.data.map((item, index) => {
        const newItem: Id & SettingTable = {
            id: item.code,
            ...item,
        };

        return newItem;
    }),
});
